import React, { useEffect } from 'react';
import { Result } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { PageContainer, PageContent } from 'app/components/common'; 
import { Translate, authService } from '../../../services';
import './styles.less';
import { IS_HOYA_THEME, IS_SEIKO_THEME } from '../../../branding';
import { getOtherBrandReroute } from '../../../branding/utils/switchBrands';

export const NoAuthPage = () => {

    useEffect( () => {

        const isAuthenticated = authService.isAuthenticated();
        if ( isAuthenticated ) {
            const userTags = authService.getTags() || [];

            const violatesHoya = ( IS_HOYA_THEME && !userTags.includes( 'ishoyalearningcenteruser' ) );
            const violatesSeiko = ( IS_SEIKO_THEME && !userTags.includes( 'isseikoacademyuser' ) );

            if ( violatesHoya && violatesSeiko ) {return;}

            if ( violatesHoya || violatesSeiko ) {
                const brandReroute = getOtherBrandReroute();
                if ( brandReroute ) {
                    location.href = 'https://' + brandReroute;
                }
            }
        }
    }, [] );

    return (
        <PageContent>
            <PageContainer> 
                <Result 
                    icon={ <InfoCircleOutlined /> }
                    title={ <Translate.Text value="page.notAuthorized.name" /> }
                    subTitle={ <Translate.Text value="page.notAuthorized.description" /> }
                    
                />
            </PageContainer>
        </PageContent>
    );
};
